const CALL_CHANNEL_NAME = "mantle-app-telehealth-call";

const CALL_TAKEOVER_MESSAGE = "call-takeover";

interface CallTakeoverMessage {
    type: typeof CALL_TAKEOVER_MESSAGE;
    roomName: string;
}

const canUseBroadcastChannel =
    typeof window !== "undefined" && "BroadcastChannel" in window;

let jitsiScriptPromise: Promise<void> | null = null;

export function loadJitsiScript(domain: string): Promise<void> {
    if (window.JitsiMeetExternalAPI) {
        return Promise.resolve();
    }

    if (!jitsiScriptPromise) {
        jitsiScriptPromise = new Promise<void>((resolve, reject) => {
            const script = document.createElement("script");

            script.src = `https://${domain}/external_api.js`;
            script.async = true;
            script.onload = () => resolve();
            script.onerror = () =>
                reject(new Error("Failed to load Jitsi API"));

            document.body.appendChild(script);
        }).catch((err) => {
            jitsiScriptPromise = null;

            throw err;
        });
    }

    return jitsiScriptPromise;
}

export function claimCall(
    roomName: string,
    onCallTakenOver: () => void
): () => void {
    if (!canUseBroadcastChannel) {
        return () => undefined;
    }

    const channel = new BroadcastChannel(CALL_CHANNEL_NAME);

    channel.onmessage = (event: MessageEvent<CallTakeoverMessage>) => {
        if (
            event.data?.type === CALL_TAKEOVER_MESSAGE &&
            event.data.roomName === roomName
        ) {
            onCallTakenOver();
        }
    };

    channel.postMessage({ type: CALL_TAKEOVER_MESSAGE, roomName });

    return () => channel.close();
}
